var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baby',{attrs:{"weight":2 * _vm.weight / (_vm.max_weight + _vm.min_weight),"height":2 * _vm.height / (_vm.max_height + _vm.min_height),"gender":_vm.gender,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }